import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import {
  EventCustomerValidationStatus,
  EventSurveyStatus
} from '../../../../models/_enum-collections';
import { CustomerSurveyPreviewEventDetails } from '../../../../models/customer-survey-preview-event-details.model';
import { currentResponse } from '../../../../models/customer-survey-response.model';
import { CustomerSurveyModel } from '../../../../models/customer-survey.,model';
import { CustomerValidationInfo } from '../../../../models/customer-validation-info.model';
import { CustomerPreviewInput } from '../../../../models/customer-validation-preview-input.model';
import { EventCustomerAttendee } from '../../../../models/event-customer-attendee-dropdown.model';
import { EventCustomers } from '../../../../models/event-customers.model';
import { EventSurveyRejectReason } from '../../../../models/event-survey-reject-reason.model';
import { CustomerSurvey } from '../../../../models/customer-survey-submission.model';
import { CommonSharedModule } from '../../../common/shared.module';
import { EventEditService } from '../../../services/event-edit.service';

@Component({
  selector: 'app-customer-survey-preview',
  templateUrl: './customer-survey-preview.component.html',
  styleUrls: ['./customer-survey-preview.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class CustomerSurveyPreviewComponent implements OnInit {
  @Input() customerSurveyPreviewInput!: CustomerPreviewInput;
  @Output() reLoadList: EventEmitter<any> = new EventEmitter<any>();
  @Output() closePreviewModal = new EventEmitter<boolean>();
  formCustomerSurveyRejection!: FormGroup;
  canShowRejectionModalDisplay = false;
  eventCustomerSurvey?: CustomerSurveyModel;
  custSurveyEventDetail!: CustomerSurveyPreviewEventDetails;
  rejectionReason!: EventSurveyRejectReason[];
  msgsUsageDetails!: any[];
  eventCustomers!: EventCustomers[];
  eventCustomersFullList!: EventCustomers[];
  eventAttendees!: EventCustomerAttendee[];
  customerStatusOptions!: any[];
  selectedCustomerStatus!: EventCustomerValidationStatus;
  selectedEventCustomer!: EventCustomers;
  selectedEventCustomerAttendee!: EventCustomerAttendee;
  customerAttendeeSurveys!: currentResponse[];
  custValidationInfo!: CustomerValidationInfo;
  eventCustomerValidationDetail = '';
  isCustomerSurveyPreviewLoading = true;
  eventId!: number;
  eventIdList!: number[];
  eventIndex!: number;
  canShowCustomerPreviewModel!: boolean;
  isSurveyResponseload = false;
  attendeeStatusId!: number;
  isApproveReject!: boolean;
  isOneToMany!: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private eventEdit: EventEditService
  ) {}

  ngOnInit() {
    this.OnFormGroup();

    this.eventId = this.customerSurveyPreviewInput.eventId;
    this.eventIdList = this.customerSurveyPreviewInput.eventIdList || [];
    this.eventIndex = this.eventIdList.indexOf(
      this.customerSurveyPreviewInput.eventId
    );

    this.customerStatusOptions = Object.keys(EventCustomerValidationStatus)
      .filter(key => isNaN(Number(key)))
      .map(key => ({
        statusName: key,
        value: EventCustomerValidationStatus[key]
      }));
    this.selectedCustomerStatus = this.customerStatusOptions.find(
      option => option.value === EventCustomerValidationStatus.Approved
    );

    this.showCustomerSurveyPreview();
  }

  OnFormGroup() {
    this.formCustomerSurveyRejection = this.formBuilder.group({
      rejectionReason: []
    });
  }

  showCustomerSurveyPreview() {
    this.canShowCustomerPreviewModel = true;
    this.isApproveReject = false;

    this.getCustomerDropdown(this.eventId);
    this.getEventDetails(this.eventId);
    this.getRejectionReasonDropDown();
  }

  getRejectionReasonDropDown() {
    this.eventEdit
      .getEventSurveyRejectionReasonDropDown()
      .subscribe(eventCustomerRejectionReasons => {
        this.rejectionReason = eventCustomerRejectionReasons;
      });
  }

  getEventDetails(eventId) {
    this.eventEdit
      .getCustomerSurveyPreviewDetails(eventId)
      .subscribe(eventSurveyPreviewDetails => {
        if (eventSurveyPreviewDetails) {
          this.custSurveyEventDetail = {
            eventID: eventSurveyPreviewDetails.eventID,
            workshopType: eventSurveyPreviewDetails.workshopType,
            partnerOrganization: eventSurveyPreviewDetails.partnerOrganization,
            dayExpiration90: eventSurveyPreviewDetails.dayExpiration90,
            statusId: eventSurveyPreviewDetails.statusId
          };
        }
      });
  }

  onNextClick() {
    this.canShowCustomerPreviewModel = false;
    this.eventId = this.eventIdList[++this.eventIndex];
    this.showCustomerSurveyPreview();
    this.selectedEventCustomerAttendee = {} as EventCustomerAttendee;
    this.selectedCustomerStatus = this.customerStatusOptions.find(
      option => option.value === EventCustomerValidationStatus.Approved
    );
  }

  onPreviousClick() {
    this.canShowCustomerPreviewModel = false;
    this.eventId = this.eventIdList[--this.eventIndex];
    this.showCustomerSurveyPreview();
    this.selectedEventCustomerAttendee = {} as EventCustomerAttendee;
    this.selectedCustomerStatus = this.customerStatusOptions.find(
      option => option.value === EventCustomerValidationStatus.Approved
    );
  }
  onDenyOpen() {
    this.canShowRejectionModalDisplay = true;
  }

  closeDeclineModal() {
    this.canShowRejectionModalDisplay = false;
    this.formCustomerSurveyRejection.reset();
  }

  IsCustomerSurveyRejected(): boolean {
    if (this.attendeeStatusId !== undefined) {
      return this.attendeeStatusId == EventSurveyStatus.Rejected;
    }
    return false;
  }

  IsCustomerSurveyApproved(): boolean {
    if (this.attendeeStatusId !== undefined) {
      return this.attendeeStatusId == EventSurveyStatus.Completed;
    }
    return false;
  }

  checkForPrevious() {
    return !(this.eventIndex == 0);
  }
  checkForNext() {
    return !(this.eventIndex == this.eventIdList.length - 1);
  }

  onDeny() {
    this.updateEventCustomerSurvey(EventSurveyStatus.Rejected);
  }

  submitForApproval() {
    this.updateEventCustomerSurvey(EventSurveyStatus.Completed);
  }

  getCustomerDropdown(eventId: number) {
    this.eventCustomers = [];
    this.eventAttendees = [];
    this.eventEdit
      .getEventCustomersDropDown(eventId)
      .subscribe(eventCustomers => {
        if (eventCustomers && eventCustomers.length > 0) {
          this.eventCustomersFullList = eventCustomers;
          this.eventCustomers = this.eventCustomersFullList.filter(
            x =>
              x.eventCustomerValidationStatusId ==
              EventCustomerValidationStatus.Approved
          );
          this.selectedEventCustomer = this.eventCustomers[0];

          if (this.eventCustomers && this.eventCustomers.length > 0) {
            this.getAttendeeDropdown(
              eventId,
              this.selectedEventCustomer.eventCustomerId
            );
          }
        }
      });
  }

  getAttendeeDropdown(eventId: number, eventCustomerId: number) {
    this.eventEdit.getSurveyDetails(eventId).subscribe(result => {
      this.isOneToMany = result.isOneToMany;
    });
    this.eventEdit
      .getEventAttendeeDropDown(eventId, eventCustomerId)
      .subscribe(eventCustomerAttendees => {
        this.eventAttendees = [];
        this.customerAttendeeSurveys = [];
        if (eventCustomerAttendees && eventCustomerAttendees.length > 0) {
          this.eventAttendees = eventCustomerAttendees;
          this.selectedEventCustomerAttendee = this.eventAttendees[0];
          this.custSurveyEventDetail.attendeeName =
            this.selectedEventCustomerAttendee.attendeeName;
          this.isCustomerSurveyPreviewLoading = false;
          this.attendeeStatusId = this.selectedEventCustomerAttendee.statusId;
          this.getCustomerSurveyInfo(
            this.selectedEventCustomerAttendee.surveyGuid
          );
        } else {
          this.isCustomerSurveyPreviewLoading = true;
        }
      });
  }

  updateEventCustomerSurvey(statusId) {
    this.isApproveReject = true;
    const eventRejection: EventSurveyRejectReason =
      this.formCustomerSurveyRejection.controls['rejectionReason'].value;

    const customerSurveysSubmissionModel = {
      CustomerSurveys: [] as any
    };

    const customerSurveySubmission: CustomerSurvey = {
      EventSurveyRejectReasonIdList: [],
      EventAttendeeSurveyMappingId:
        this.selectedEventCustomerAttendee.eventAttendeeSurveyMappingId,
      StatusId: statusId,
      EventTypeSurveyMappingId:
        this.selectedEventCustomerAttendee.eventTypeSurveyMappingId
    } as any;

    if (statusId === EventSurveyStatus.Rejected) {
      customerSurveySubmission.EventSurveyRejectReasonIdList[0] =
        eventRejection.eventSurveyRejectReasonId || -1;
    }

    customerSurveySubmission.SurveyGUID =
      this.selectedEventCustomerAttendee.surveyGuid;

    customerSurveysSubmissionModel.CustomerSurveys.push(
      customerSurveySubmission
    );

    this.eventEdit
      .updateCustomerSurveys(customerSurveysSubmissionModel)
      .subscribe(
        () => {
          if (statusId == EventSurveyStatus.Completed) {
            this.showMessage('Customer Survey Approved', false);
          } else {
            this.showMessage('Customer Survey Rejected', false);
          }
          this.attendeeStatusId = statusId;

          const index = this.eventAttendees.indexOf(
            this.selectedEventCustomerAttendee
          );
          this.selectedEventCustomerAttendee.statusId = statusId;
          this.eventAttendees[index] = this.selectedEventCustomerAttendee;
        },
        error => {
          this.showMessage(error.error.errorInfo, true);
        }
      );

    this.closeDeclineModal();
  }

  onCustomerChange(event) {
    this.getAttendeeDropdown(this.eventId, event.value.eventCustomerId);
  }

  onAttendeeChange(event) {
    this.custSurveyEventDetail.attendeeName = event.value.attendeeName;
    this.attendeeStatusId = this.selectedEventCustomerAttendee.statusId;
    this.getCustomerSurveyInfo(event.value.surveyGuid);
  }

  onStatusChange(event) {
    this.selectedCustomerStatus = event.value;
    this.eventCustomers = this.eventCustomersFullList.filter(
      x => x.eventCustomerValidationStatusId == event.value.value
    );
    this.customerAttendeeSurveys = [];
    this.selectedEventCustomer = {} as EventCustomers;
    this.selectedEventCustomerAttendee = {} as EventCustomerAttendee;
    this.eventAttendees = [];
  }

  getCustomerSurveyInfo(eventCustomerId) {
    this.isSurveyResponseload = true;
    this.eventEdit
      .getCustomerSurveyResponse(eventCustomerId)
      .subscribe(customerSurveyResponse => {
        this.customerAttendeeSurveys = customerSurveyResponse.current;
        this.isSurveyResponseload = false;
        if (this.customerAttendeeSurveys == null) {
          this.isCustomerSurveyPreviewLoading = true;
        } else {
          this.isCustomerSurveyPreviewLoading = false;
        }
      });
  }

  get customerDenyButtonEnable(): boolean {
    return (
      this.formCustomerSurveyRejection.controls['rejectionReason'].value != null
    );
  }

  showMessage(message: string, isError?: boolean) {
    this.isApproveReject = false;
    this.msgsUsageDetails = [];
    this.msgsUsageDetails.push({
      severity: !isError ? 'success' : 'error',
      detail: message
    });
  }

  closePreview() {
    this.canShowCustomerPreviewModel = false;
    this.reLoadList.emit(true);
    this.closePreviewModal.emit(false);
  }
}
